import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import ApplicationImg from '../../../assets/img/claims/customers/application.svg';
import ClaimCustomersCustomizeImg from '../../../assets/img/claims/customers/customize.svg';
import ClaimCustomersFeatureCommunicationImg from '../../../assets/img/claims/customers/feature-communication.svg';
import ClaimCustomersInfoImg from '../../../assets/img/claims/customers/info.svg';
import { HeaderContent } from '../../../components/HeaderContent';
import { UnderLicenseClaim } from '../../../components/new-layout/UnderLicenseClaim';
import { intl } from '../../../helpers/IntGlobalProvider';
import { useRetrieveActiveProject } from '../../../hooks/project/useRetrieveActiveProject';
import { useRetrieveSupportDocs } from '../../../hooks/support-docs/useRetrieveSupportDocs';
import { useRetrieveUser } from '../../../hooks/user/useRetrieveUser';
import { useRetrieveUserCredentials } from '../../../hooks/user/useRetrieveUserCredentials';
import Text from '../../../react-components/Text';
import { CustomersStylingConfiguration } from './configuration';
import { CustomersStylingPreview } from './preview';

export const CustomersStyling = () => {
  const { data: user } = useRetrieveUser();
  const { retrieveDoc } = useRetrieveSupportDocs();
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { data: activeProject } = useRetrieveActiveProject();

  if (!activeProject || !userCredentials) return null;

  if (!userCredentials.subscription.test(`customers`)) {
    return (
      <UnderLicenseClaim headerText={intl.formatMessage({ id: `customers.under_gorilla_claim.title` })}>
        <Grid container direction="column" alignItems="center">
          <VSpacer large />
          <VSpacer medium />

          <Grid
            item
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ maxWidth: `700px` }}
          >
            <img draggable="false" src={ApplicationImg} alt="" height="200" width="200" />
            <VSpacer large />
            <Text
              variant="body-medium"
              style={{ textAlign: `center`, fontSize: `13px` }}
              intlId="customers.under_gorilla_claim.header"
            />
          </Grid>

          <VSpacer large />

          <VSpacer large />

          <Grid item container direction="row" style={{ gap: `20px` }} alignItems="flex-start" justifyContent="center">
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img draggable="false" src={ClaimCustomersInfoImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="customers.under_gorilla_claim.content.1"
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img draggable="false" src={ClaimCustomersFeatureCommunicationImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="customers.under_gorilla_claim.content.2"
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img draggable="false" src={ClaimCustomersCustomizeImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="customers.under_gorilla_claim.content.3"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </UnderLicenseClaim>
    );
  }

  return (
    <Grid container direction="column" wrap="nowrap" style={{ height: `100%` }}>
      <HeaderContent
        titleIntlId="project.settings.styling"
        article={{
          intlId: `customers.app.styling.article`,
          link: retrieveDoc({ supportPage: `customersWhiteLabel`, language: user?.language.value }),
        }}
        styles={{
          container: {
            padding: `16px 22px`,
            backgroundColor: RoutalPalette.white,
            borderBottom: `1px solid ${RoutalPalette.neutral10}`,
            maxHeight: `120px`,
          },
        }}
      />

      <Grid
        container
        direction="row"
        wrap="nowrap"
        style={{ height: `calc(100% - 73px)`, backgroundColor: RoutalPalette.neutral00 }}
      >
        <Grid
          item
          container
          wrap="nowrap"
          direction="column"
          style={{
            padding: `0`,
            width: `380px`,
            overflow: `auto`,
            borderRight: `1px solid ${RoutalPalette.primary00}`,
          }}
        >
          <CustomersStylingConfiguration project={activeProject} />
        </Grid>
        <Grid item container direction="column" style={{ flex: `1`, backgroundColor: `#F1F1F1` }}>
          <CustomersStylingPreview project={activeProject} />
        </Grid>
      </Grid>
    </Grid>
  );
};
